<template lang="pug">
  .camps
    .camps__search-form
      button.button.button_full.hide-xs-up.search-form-button-toggle(
        @click="isShowFilter = toggleFilter()"
      )
        .button__text Фильтр
      search-form(
        v-show="isShowFilter"
        without-title
      )
    .camps__body
      .camps__map
        l-map(
          ref='mainMap'
          id='mainMap'
          :zoom='zoom'
          :center='center'
          :options='mapOptions'
        )
          l-tile-layer(
            :url='url'
          )
          l-marker(
            v-for='(camp, $index) in campsMapData'
            v-if="camp.geo_lat && camp.geo_lon"
            :data-id="$index"
            :lat-lng='[camp.geo_lat, camp.geo_lon]'
            :key='$index'
            :icon='generateIcon()'
          )
            l-popup
              .obj.obj_tooltip
                .obj__media(
                  v-if="camp.photos.length > 0"
                )
                  img(
                    v-bind:src="camp.photos[0].preview_376x340"
                  )
                router-link.obj__body(
                :to="`/pages/camps/${camp.id}/`"
                )
                  .obj__title {{ camp.name }}
                  .obj__description(
                    v-bind:title='camp.address'
                  ) {{ camp.address ? `${camp.address.region}, ${camp.address.area}` : "" }}
                  <!--.obj__date Сезон: {{ shiftSeasons[camp.season] }}-->
      .camps__side.camps-side(
        ref="sideBlock"
      )
        .camps-side__header
          .camps-side__title
            | {{ caseSetting(campsCount, vocabulary.found) }} {{ campsCount }} {{ caseSetting(campsCount, vocabulary.camp) }}
          <!--.camps-side__filter-->
            <!--select.select-->
              <!--option По рейтингу-->
              <!--option По рейтингу-->
              <!--option По рейтингу-->
        .camps-side__body
          .obj-list.obj-list_vertical
            .obj-list__item(
              v-for="camp in campsData"
            )
              .obj.obj_horizontal
                .obj__media
                  image-slider(
                  :data-images="camp.slider_preview"
                  )
                router-link(:to="`/pages/camps/${camp.id}/`").obj__body
                  .obj__title {{ camp.name }}
                  <!--.obj__rating-->
                    <!--rating(-->
                      <!--:value="camp.rating"-->
                    <!--)-->
                  .obj__description(
                    v-bind:title='camp.address'
                  ) {{ camp.address ? `${camp.address.region}, ${camp.address.area}` : "" }}
                  <!--.obj__date Сезон: {{ shiftSeasons[camp.season] }}-->
    .camps__footer
      main-footer
</template>

<script>
import {mapActions, mapState} from "vuex";

import L from "leaflet";
import {LMap, LTileLayer, LMarker, LPopup} from "vue2-leaflet";

import ImageSlider from "@/components/imageSlider/ImageSlider.vue";
import searchForm from "@/components/searchForm/SearchForm.vue";
import Rating from "@/components/rating/Rating.vue";
import MainFooter from "@/components/footer/Footer.vue";

export default {
  name: "Camps",
  components: {
    searchForm,
    ImageSlider,
    Rating,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    MainFooter
  },
  data() {
    return {
      isShowFilter: false,
      toggleFilterIsActive: false,
      windowWidth: window.innerWidth,
      zoom: 8,
      center: L.latLng(55.315919, 50.985943),
      url: "https://a.tile.openstreetmap.de/{z}/{x}/{y}.png",
      // url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      mapOptions: {
        attributionControl: false
      },
      vocabulary: {
        found: ["Найден", "Найдено", "Найдено"],
        camp: ["лагерь", "лагеря", "лагерей"]
      },

      campsData: [],
      campsMapData: [],
      campsCount: null,
      scrollStatus: true,
      requestParams: null,
      campsPaginationQt: 30,
      campsOffset: 0
    };
  },
  computed: {
    shiftSeasons() {
      return this.$store.getters.shiftSeasons();
    }
  },
  methods: {
    ...mapActions(["getCamps", "getCampsMap"]),
    generateIcon() {
      return L.icon({
        iconUrl: require("../../../../assets/images/map/marker.svg"),
        iconSize: [40, 40],
        iconAnchor: [20, 20]
      });
    },
    caseSetting(number, words) {
      number = +(number + "").slice(-2);
      for (var i = 11; i <= 14; i++) {
        if (number === i) {
          return words[2];
        }
      }
      number = +(number + "").slice(-1);
      for (var j = 2; j <= 4; j++) {
        if (number === j) return words[1];
      }
      if (number === 1) {
        return words[0];
      } else {
        return words[2];
      }
    },
    toggleFilter() {
      this.toggleFilterIsActive = !this.toggleFilterIsActive;
      return !this.isShowFilter;
    },
    setIsShowFilter(windowWidth) {
      if (windowWidth > 720) {
        this.isShowFilter = true;
      } else {
        if (!this.toggleFilterIsActive) {
          this.isShowFilter = false;
        }
      }
    },

    setRequestParams() {
      this.requestParams = this.$route.query;
      this.requestParams.limit = this.campsPaginationQt;
      this.requestParams.offset = this.campsOffset;
    },
    dataRequest(params, isAddition) {
      this.getCamps({params}).then((res) => {
        if (!isAddition) {
          this.campsData = [];
        }
        this.campsCount = res.count;
        if (res.results.length === 0) {
          this.scrollStatus = false;
          return;
        }
        const arr = res.results.map(camp => {
          camp.slider_preview = camp.photos
            .map(photo => photo.preview_376x340)
            .slice(0, 5);
          return camp;
        });
        this.campsData = this.campsData.concat(arr);
        this.scrollStatus = true;
        this.requestParams.offset += this.campsPaginationQt;
      });
    },
    buildCamps() {
      this.$root.$emit("on-show-preloader");
      this.dataRequest(this.requestParams, false);
      //загрузка данных для карты
      this.getCampsMap({
        params: this.requestParams
      }).then((res) => {
        this.campsMapData = res;
        this.$root.$emit("on-hide-preloader");
      });
    }
  },
  mounted() {
    this.setRequestParams();
    this.buildCamps();

    this.setIsShowFilter(this.windowWidth);
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };

    this.$refs.sideBlock.addEventListener("scroll", (e) => {
      const clientHeight = this.$refs.sideBlock.clientHeight;
      const scrollHeight = this.$refs.sideBlock.scrollHeight;
      const scrollTop = this.$refs.sideBlock.scrollTop;
      const point = scrollHeight / this.requestParams.offset * 8;
      if (scrollTop > (scrollHeight - clientHeight - point) && this.scrollStatus) {
        this.scrollStatus = false;
        this.dataRequest(this.requestParams, true);
      }
    });
  },
  watch: {
    "$route.query"() {
      this.setRequestParams();
      this.buildCamps();
      this.$refs.sideBlock.scrollTop = 0;
    },
    windowWidth(val) {
      this.setIsShowFilter(val);
    }
  }
};
</script>
